import React, { useRef, useEffect } from "react";
import { Contact } from "./contact/contact";
import { Banner } from "./banner/banner";
import Fade from "react-reveal/Fade";
import { PersonDeskSvg } from '../../assets/images/svg/personDesk/personDesk'
import './style.css'

export const Home = () => {
  //scroll to contact
  const scrollToRef = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };
  const myRef = useRef(null);
  const executeScroll = () => scrollToRef(myRef);

  useEffect(() => {
    document.title = "Home - Portfolio AV";
  }, []);

  return (
    <div>
      <Banner executeScroll={executeScroll} />

      <div style={{ position: "relative" }}>
        <div className="PrimaryBox">
          <div className="Container">
            <Fade bottom>
              <div className="PrimaryBoxGrid">
                <div className="PrimaryBoxGrid_Text">
                  <h1>Wie ben ik?</h1>
                  <div className="PrimaryText">
                    Ik ben een Web & App developer die een passie heeft voor het
                    creëren van websites en apps. Ik kom graag uniek uit de hoek
                    en probeer graag nieuwe dingen uit. Het liefst investeer ik
                    mijn tijd in het front-end gedeelte maar ik ben niet bang om
                    ook enkele delen van het back-end gedeelte aan te pakken.
                  </div>
                </div>

                <div className="PrimaryBoxGrid_Image">
                  <PersonDeskSvg />
                </div>
              </div>
            </Fade>
          </div>
        </div>

        <div className="SecondaryBox">
          <div className="Container">
            <Fade bottom>
              <h1>Opleidingen</h1>

              <div className={["ExperienceGrid GridBottomMargin"]}>
                <div>
                  <h2 className="PrimarySubTitle">MCT 2017-2020</h2>
                  <div>
                    In MCT leerde ik omgaan met verschillende
                    programmeertechnieken. Hierbij kreeg ik theorielessen die
                    dan direct werden omgezet in de praktijk met de labolessen.
                    Hierin koos ik voor de afstudeerrichting Web & App
                    developer.
                  </div>
                </div>

                <div>
                  <h2 className="PrimarySubTitle">
                    Informaticabeheer 2011-2017
                  </h2>
                  <div>
                    Hier leerde ik de basis van de ICT wereld zoals de
                    onderdelen van de computer, een stukje netwerkbeheer, sites
                    maken enz..
                  </div>
                </div>
              </div>
            </Fade>

            <Fade bottom>
              <h1>Werkervaring</h1>

              <div className="ExperienceGrid">
                <div>
                  <h2 className="PrimarySubTitle">Proceedix 2020</h2>
                  <div>
                    Hier volgde ik mijn stage voor mijn laatste jaar MCT. Hier
                    leerde ik hoe alles verliep in de bedrijfswereld. Ik werkte
                    hier aan projecten met React Native en Xamarin. Hier leerde
                    ik ook werken met Redux, Redux-Saga, Styled-Components enz..
                  </div>
                </div>

                <div>
                  <h2 className="PrimarySubTitle">Strong-IT 2017</h2>
                  <div>
                    Hier volgde ik mijn stage voor mijn laatste jaar
                    Informaticabeheer. Hier testte ik Wordpress uit om te zien
                    of dit wel handig kon zijn om te gebruiken binnen in het
                    bedrijf.
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>

        <div className="TertiaryBox">
          <div className="Container">
            <Fade bottom>
              <h1>Skills</h1>
              <div className="SkillsGrid">
                <div>
                  <h2 className="PrimarySubTitle">Programmeertalen</h2>
                  <ul>
                    <li>HTML</li>
                    <li>CSS</li>
                    <li>JavaScript</li>
                    <li>C#</li>
                    <li>SQL</li>
                    <li>PHP</li>
                  </ul>
                </div>

                <div>
                  <h2 className="PrimarySubTitle">Frameworks</h2>
                  <ul>
                    <li>React JS & React Native</li>
                    <li>Vue JS</li>
                    <li>Svelte JS</li>
                    <li>Xamarin</li>
                    <li>.NET</li>
                  </ul>
                </div>

                <div>
                  <h2 className="PrimarySubTitle">Adobe</h2>
                  <ul>
                    <li>XD</li>
                    <li>Premier</li>
                    <li>Photoshop</li>
                    <li>After Effects</li>
                  </ul>
                </div>

                <div>
                  <h2 className="PrimarySubTitle">Talen</h2>
                  <ul>
                    <li>Nederlands (Moedertaal)</li>
                    <li>Engels (Professionele werkvaardigheid)</li>
                    <li>Frans (Basisvaardigheid)</li>
                  </ul>
                </div>
              </div>
            </Fade>
          </div>
        </div>
        
        <div className="SecondaryBox" ref={myRef}>
          <div className="Container">
            <Fade bottom>
              <Contact />
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
};
